// @flow
import { Element } from 'react-scroll';
import { graphql } from 'gatsby';
import * as React from 'react';

import { Layout } from '../components/layout';
import History from '../components/sections/history';
import LandingPage from '../components/sections/landing-page';
import Map from '../components/map';
import ProductListing from '../components/product-listing';
import Projects from '../components/sections/projects';
import Services from '../components/sections/services';
import Store from '../components/sections/store';

export const query = graphql`
  query {
    shopifyCollection(handle: { eq: "frontpage" }) {
      products {
        ...ProductCard
      }
    }
    contentfulLandingPage {
      seccionesDeServicio {
        id
        nombre
        servicios {
          nombre
          id
          descripcion {
            descripcion
          }
          galeria {
            gatsbyImageData(
              width: 500
              layout: FULL_WIDTH
              quality: 100
              formats: WEBP
            )
          }
        }
      }
    }

    contentfulGaleriaDeProyecto {
      nombre
      proyectos {
        id
        nombre
        slug
        galeria {
          fluid {
            srcWebp
          }
          gatsbyImageData(
            aspectRatio: 1.5
            quality: 100
            width: 600
            height: 400
            formats: WEBP
            layout: CONSTRAINED
            cornerRadius: 0
            cropFocus: CENTER
          )
        }
      }
    }
  }
`;

// flow types
type IndexPageProps = {
  data: any,
};

export default function IndexPage({ data }: IndexPageProps) {
  return (
    <Layout>
      <LandingPage />
      <ProductListing
        title="Productos populares"
        products={data?.shopifyCollection?.products}
      />
      <Store />
      <Element name="index-gallery">
        <Projects
          items={data?.contentfulGaleriaDeProyecto?.proyectos}
          title={data?.contentfulGaleriaDeProyecto?.nombre}
        />
      </Element>
      <Element name="index-services">
        <Services items={data?.contentfulLandingPage.seccionesDeServicio} />
      </Element>
      <History />
      <Element name="index-contact">
        <Map />
      </Element>
    </Layout>
  );
}
